var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"x-small":""},on:{"click":_vm.getQuestionSet}},[_vm._v("getQuestionSet")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }